<template lang="html">
   <div class="footer clearfix">
      <div class="left">
         &copy; {{new Date().getFullYear()}} <b>{{main_lang.brand}}</b> all rights reserved
      </div>
      <div class="right">
         <router-link :to="{name: 'LogIn'}" class="link">
            Get Help
         </router-link>
         <router-link :to="{name: 'LogIn'}" class="link">
            Documentation
         </router-link>
      </div>
   </div>
</template>

<script>
export default {
   data () {
      return {
         main_lang
      }
   },
   mounted(){

   }
}
</script>

<style lang="scss">
   .footer{
      padding: 20px 10px;
      font-size: 12px;
      margin: 50px 0 0 0;
      border-top: dashed 1px $border-grey;

      .left{
         float: left;
         padding: 0 0 0 15px;
      }
      .right{
         float: right;

         .link{
            margin: 0 10px;
            font-weight: 600;
         }
      }
   }
</style>